import React, { useContext } from "react";
import themeContext from "../../../context/theme/ThemeContext";
import { darkTheme, lightTheme } from "../../../constants/Themes";
import userContext from "../../../context/users/UserContext";
import { updateUserSettings } from "../../../service/UserService";
import loaderContext from "../../../context/loader/LoaderContext";

const ThemeTypes = (props) => {
  const { theme, themeName, setThemeName, setTheme, setUserSettings, handleThemeProviderChange } = useContext(themeContext);
  const { userId, userSettings } = useContext(userContext);
  const { setLoaderRunning,ref } = useContext(loaderContext);

  const changeTourUpdate = async(themeValue,studyListTour,viewerTour,showThemePreference) => {
    let body = {
      userSettings:{
        "theme":themeValue,
        "studylistTour":studyListTour == null || studyListTour == undefined ? true : studyListTour,
        "viewerTour":viewerTour == null || viewerTour == undefined ? false : viewerTour,
        "showThemePreference": showThemePreference != null && showThemePreference != undefined ? showThemePreference : false,
      }
      
    }
    console.log("-- Body ---",body);
    try{
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await updateUserSettings(body.userSettings);
      if (response.status === 200 && response.data.result === "SUCCESS") {
          setUserSettings(body.userSettings);
          setLoaderRunning(false);
          ref.current.complete();
      }else{
        setLoaderRunning(false);
        ref.current.complete();
      }
    }catch(e){
      setLoaderRunning(false);
      ref.current.complete();
    }
  }

  const changeTheme = async(value) => {
    handleThemeProviderChange(value);
    setThemeName(value);
    changeTourUpdate(value,userSettings.studyListTour,userSettings.viewerTour,false);
  };


  return (
    <>
      <ul className="dropdown-menu-header scrollable-menu modal-scroll-annotation">
        {/* <li
          className={`"header-theme-li header-top-bar-list-text " ${
            themeName == "light" ? "active-theme-li" : ""
          }`}
          onClick={()=>{console.log("Light");changeTheme("light")}}
          style={{ marginLeft: "0px", padding: "10px" }}
        >
          Light
        </li> */}
        <li
          className={`"header-theme-li header-top-bar-list-text " ${
            themeName == "dark-midnight" ? "active-theme-li" : ""
          } `}
          onClick={()=>{console.log("Midnight-Blue");changeTheme("dark-midnight")}}
          style={{ marginLeft: "0px", padding: "10px" }}
        >
          Midnight Dark
        </li>
        <li
          className={`"header-theme-li header-top-bar-list-text " ${
            themeName == "blue-theme" ? "active-theme-li" : ""
          } `}
          onClick={()=>{console.log("Midnight-Blue");changeTheme("blue-theme")}}
          style={{ marginLeft: "0px", padding: "10px" }}
        >
          Royal Blue
        </li>
        <li
          className={`"header-theme-li header-top-bar-list-text "  ${
            themeName == "dark" ? "active-theme-li" : ""
          }`}
          onClick={()=>{console.log("Dusk");changeTheme("dark")}}
          style={{ marginLeft: "0px", padding: "10px" }}
        >
          Dusk
        </li>
        <li
          className={`"header-theme-li header-top-bar-list-text "  ${
            themeName == "light" ? "active-theme-li" : ""
          }`}
          onClick={()=>{console.log("light");changeTheme("light")}}
          style={{ marginLeft: "0px", padding: "10px" }}
        >
          Light
        </li>
      </ul>
    </>
  );
};

export default ThemeTypes;
